import eyerCloud from '@/config/eyercloud'

class ClaimConfigService {

  async get(params) {
    const response = await eyerCloud.post('/api/v2/eyercloud/clinic/claim-config/get', params)
    return response.data
  }

  async save(params) {
    const response = await eyerCloud.post('/api/v2/eyercloud/clinic/claim-config/save', params)
    return response.data
  }

  async preview(params) {
    const response = await eyerCloud.post('/api/v2/eyercloud/clinic/claim-config/preview', params)
    return response.data
  }

  async previewExam(params) {
    const response = await eyerCloud.post('/api/v2/eyercloud/exam/claim-config/preview', params)
    return response.data
  }

  async exportBatchClaimsFromExams(params) {
    const response = await eyerCloud.post('/api/v2/eyercloud/claim/export-batch-claims', params)
    return response.data
  }
}

export default new ClaimConfigService()
